/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import Cookies from 'universal-cookie';

export const getEnterpriseId = (state) => state.member?.enterpriseId?.enterpriseId || '';
export const getEnterpriseIdLoadingError = (state) => state.member.enterpriseId.error;
export const getEnterpriseIdLoadingState = (state) => state.member.enterpriseId.loading;
export const getEnterpriseIdSegments = (state) => state.member.enterpriseId.segments;

// qubit POC
export const getVisitorIdAndEID = (state) => {
    let visitorId = null;
    if (typeof window !== 'undefined') {
        const cookies = new Cookies();
        visitorId = cookies.get('_qubitTracker');
    }
    const enterpriseId = state.member.enterpriseId.enterpriseId;
    // if no visitor id is present, assign enterprise id
    return {
        visitorId: visitorId || enterpriseId,
        enterpriseId,
    };
};

export default {};
